import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import useKlasisTracker from "../utils/klasisTracker";

import parse from "html-react-parser";

import { Link as RouterLink, useParams } from "react-router-dom";
import { Grid, Button, useMediaQuery, useTheme } from "@mui/material";

import PageContent from "../parts/page-content/PageContent";
import ClassifierCard from "../components/ClassifierCard";
import axios from "axios";
import useKlasisRouting from "../utils/klasisRouting";
import { ApiRoutes } from "../configuration/apiRoutes";
import { TopClassifiersResponse } from "../models/TopClassifiersResponse";
import { Translations } from "../localization/translations";
import { defaultLocale } from "../constants/languages";

const Home: React.FC = () => {
    let { locale } = useParams();
    const { t } = useTranslation();
    const { klasisTrackPageView } = useKlasisTracker();

    const [data, setData] = useState<TopClassifiersResponse>();

    const { klasisRoute } = useKlasisRouting();

    const theme = useTheme();
    const mdDown = useMediaQuery(theme.breakpoints.down("md"));

    useEffect(() => {
        klasisTrackPageView();
    }, []);

    useEffect(() => {
        axios
            .get<TopClassifiersResponse>(
                ApiRoutes.Classifiers.Top({
                    localeCode: locale ?? defaultLocale,
                })
            )
            .then((response) => {
                setData(response.data);
            })
            .catch((error) => {
                console.error(error);
            });
    }, [locale]);

    return (
        <PageContent>
            <Grid
                container
                spacing={2}
                sx={
                    mdDown
                        ? { marginBottom: 2 }
                        : { padding: 4, paddingLeft: 8, paddingRight: 8 }
                }
            >
                {data?.items.map((item, key) => (
                    <Grid key={key} item xs={12} md={6}>
                        <ClassifierCard
                            to={klasisRoute(`classifications/${item.id}`)}
                            img={item.imageBase64}
                            title={`${item.name}${ item.code ? ` (${item.code})` : "" }`}
                            content={
                                item.description
                                    ? parse(item.description)
                                    : undefined
                            }
                        />
                    </Grid>
                ))}
            </Grid>
            <Grid container justifyContent="center">
                <Grid item>
                    <Button
                        variant="contained"
                        component={RouterLink}
                        to={klasisRoute("classifications")}
                    >
                        {t(Translations.navBar.button.allClassifiers)}
                    </Button>
                </Grid>
            </Grid>
        </PageContent>
    );
};

export default Home;
